export default "__VITE_ASSET__H6WjGHz9__"